const doc = [({"da":({"js":({"feedback_steps":({"edit":({"question_asked":"En anden blev spurgt", "answer_given":"En anden svarede", "no_answer":"Intet svar"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;